"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetMeta = void 0;
/**
 * メタデータを設定するカスタムフック
 * @param title
 * @param description
 */
var useSetMeta = function (title, description, shopName) {
    var pageTitle = document.title;
    var splitPageTitle = pageTitle.split(/[｜]/);
    pageTitle = splitPageTitle[0];
    pageTitle = shopName ? pageTitle + "\uFF5C" + shopName : "" + pageTitle;
    pageTitle = title ? pageTitle + "\uFF5C" + title : "" + pageTitle;
    document.title = pageTitle;
    var headData = document.head.children;
    if (!description)
        return;
    for (var i = 0; i < headData.length; i++) {
        var nameVal = headData[i].getAttribute("name");
        if (nameVal !== null) {
            if (nameVal.indexOf("description") != -1) {
                headData[i].setAttribute("content", description);
            }
        }
    }
};
exports.useSetMeta = useSetMeta;
